import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <section id="company" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-square rounded-3xl overflow-hidden border border-cyan/20 relative group">
               <div className="absolute inset-0 bg-gradient-to-tr from-cyan/20 to-transparent z-10 mix-blend-overlay"></div>
               <img 
                 src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop" 
                 alt="Futuristic Technology" 
                 className="w-full h-full object-cover grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700"
               />
               <div className="absolute bottom-8 left-8 z-20 bg-navy/80 backdrop-blur-md border border-cyan/30 p-6 rounded-2xl glow-border">
                 <h3 className="text-5xl font-heading font-bold text-cyan mb-1">8<span className="text-3xl text-white">+</span></h3>
                 <p className="text-slate-300 font-medium">Years Experience</p>
               </div>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan/10 border border-cyan/20 text-cyan text-sm font-heading mb-6">
              <span className="w-2 h-2 rounded-full bg-cyan animate-pulse"></span>
              About Company
            </div>
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-6">
              Learn About Us
            </h2>
            <p className="text-slate-400 text-lg leading-relaxed mb-8">
              <span className="text-white font-semibold">Innovant Energotech Solutions Private Limited</span> is a next-generation technology company dedicated to transforming the future of mobility, energy, and intelligent systems. 
              <br/><br/>
              At <span className="text-cyan glow-text">Vitrotechworld</span>, we specialize in pioneering advancements across <span className="text-neon">Electrification</span>, <span className="text-cyan">Artificial Intelligence</span>, <span className="text-neon">Hydrogen Fuel Cell</span> technologies, and <span className="text-cyan">Autonomous Vehicles</span>. Our core mission is to engineer sustainable, smart, and highly efficient software and hardware solutions that empower businesses to thrive in a rapidly evolving digital and physical landscape.
            </p>
            
            <div className="flex gap-4">
               <div className="w-12 h-1 bg-gradient-to-r from-cyan to-transparent mt-3"></div>
               <p className="text-sm text-slate-500 italic">Pushing boundaries. Defying limits. Engineering the future.</p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default About;